import request from '../api';
// 获取语言
export function dubbingGetLanguages(type) {
  return request.get(`/app/dubbing/getLanguages/${type}`);
}

// 文字转音频
export function dubbingDubbing(data) {
  return request.post('/app/dubbing/dubbing', data);
}
